import React__default from 'react';
import { DotsLoader } from '../../dots-loader/index.js';

var ChatLoader = function () {
    return (React__default.createElement("div", { className: 'saving for-chat for-round_loader' },
        React__default.createElement(DotsLoader, null)));
};

export { ChatLoader as default };
